import React from 'react';
import ReactExport from "react-export-excel";
import numeral from 'numeral';
import reportesFunctions from '../../reportes/reportes.functions';


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const ManifiestoEstadosPrinter = ({ data, config }) => {

    console.log(data);

  const formatMedidasBoxs = (bultos) => {
   const nuevosBultos = reportesFunctions.calulateBultos(bultos);
    const string = nuevosBultos.map((e) => {
      return `(${e.count}) ${numeral(e.alto).format('0.00')}x${numeral(e.ancho).format('0.00')}x${numeral(e.largo).format('0.00')}`;
    })
    return string.join();
  } 

  
  return (
      <ExcelFile filename={`${data.manifiesto.description}`} element={<button type="button" className="btnx btnx-warn">Exportar Excel</button>}>
         {data.estadosseleccionados.map((el, index) => (
            <ExcelSheet key={index} data={el.guias_estados_pais} name={el.estado.toUpperCase()}>
                <ExcelColumn label="RECIBO" value="guia_paquete"/>
                <ExcelColumn label="NOMBRE (SHIPPER)"  value={(col) => config.nombre_empresa }/>
                <ExcelColumn label="R.U.N."  value={(col) => config.rut_empresa }/>
                <ExcelColumn label="BULTOS"  value={(col) => col.bultos.length }/>
                <ExcelColumn label="CAJA MEDIDAS"  value={(col) => formatMedidasBoxs(col.bultos) }/>
                <ExcelColumn label="PIE CUBICOS"  value={(col) => reportesFunctions.piestotales(col.bultos, true) }/>
                <ExcelColumn label="PESO KG"  value={(col) => reportesFunctions.kgtotales(col.bultos, true) }/>
                <ExcelColumn label="NOMBRE CONSIGNATARIO"  value="cliente_receptor_nombre" />
                <ExcelColumn label="CEDULA"  value="cliente_receptor_identificacion" />
                <ExcelColumn label="CIUDAD"  value={(col) => col.ciudad_guia.ciudad.toUpperCase() } />
                <ExcelColumn label="ESTADO"  value={(col) => col.estado_guia.estado.toUpperCase() } />
                <ExcelColumn label="DIRECCIÓN"  value="cliente_receptor_direccion_entrega" />
                <ExcelColumn label="CELULAR CONTACTO"  value="cliente_receptor_telefono" /> 
            </ExcelSheet>
         ))}
      </ExcelFile>
  );
}

export default ManifiestoEstadosPrinter;

  /*       
<ExcelSheet data={data.guias_of_master} name="Clientes">
<ExcelColumn label="NOMBRE (SHIPPER)"  value={(col) => config.nombre_empresa }/>
      <ExcelColumn label="RECIBO" value="guia_paquete"/>
      <ExcelColumn label="NOMBRE (SHIPPER)"  value={(col) => config.nombre_empresa }/>
      <ExcelColumn label="R.U.N."  value={(col) => config.rut_empresa }/>
      <ExcelColumn label="BULTOS"  value={(col) => col.bultos.length }/>
      <ExcelColumn label="CAJA MEDIDAS"  value={(col) => formatMedidasBoxs(col.bultos) }/>
      <ExcelColumn label="PIE CUBICOS"  value={(col) => reportesFunctions.piestotales(col.bultos) }/>
      <ExcelColumn label="PESO KG"  value={(col) => reportesFunctions.kgtotales(col.bultos) }/>
      <ExcelColumn label="NOMBRE CONSIGNATARIO"  value="cliente_receptor_nombre" />
      <ExcelColumn label="CEDULA"  value="cliente_receptor_identificacion" />
      <ExcelColumn label="CIUDAD"  value={(col) => col.ciudad_guia.ciudad.toUpperCase() } />
      <ExcelColumn label="ESTADO"  value={(col) => col.estado_guia.estado.toUpperCase() } />
      <ExcelColumn label="DIRECCIÓN"  value="cliente_receptor_direccion_entrega" />
      <ExcelColumn label="CELULAR CONTACTO"  value="cliente_receptor_telefono" /> 
</ExcelSheet>
<ExcelSheet data={data.guias_of_master} name="Clientes_2">
  <ExcelColumn label="NOMBRE (SHIPPER)"  value={(col) => config.nombre_empresa }/>
</ExcelSheet>*/